import type { IRecordTypeDefinition } from '@platform/core/types';
import type { IFormStats } from './IFormStats';

/** Вкладки форми, які рахує прототип v4 (cust-forms: 1 + увімкнені з assignments, related, comments, files, history). */
const COUNTED_TABS: readonly string[] = ['assignments', 'related', 'comments', 'files', 'history'];

/**
 * Зведення повної форми як у прототипі v4 (cust-forms): групи, що мають поля; розміщені поля з усіх полів типу — у ключовому рядку, під
 * назвою, у групах, назва й текст статті, який показують вкладки «Читання» / «Редагування» (прототип ховає лише поля, приховані у формі);
 * вкладки — «Загальне» й увімкнені стандартні (власні вкладки модуля, як «Структура» конструктора законів, прототип не рахує); форма
 * простору (`shaped`) — форма без вкладки «Доручення»: так прототип формує власні форми фінансів і реєстрів (_fin, _reg2). Чиста функція.
 */
export function formStats(rt: IRecordTypeDefinition): IFormStats {
  const form = rt.forms?.full ?? rt.form;
  const fields = rt.fields.filter((f) => !f.hidden);
  const known = new Set(fields.map((f) => f.key));
  const tabs = (form?.tabs ?? []) as readonly string[];
  const article = tabs.includes('read') || tabs.includes('edit') ? ['body'] : [];
  const placed = new Set(['title', ...article, ...(form?.keyLine ?? []), ...(form?.underTitle ?? []), ...(form?.groups ?? []).flatMap((g) => g.fields)].filter((k) => known.has(k)));
  return {
    groups: (form?.groups ?? []).filter((g) => g.fields.some((k) => known.has(k))).length,
    placed: placed.size,
    total: fields.length,
    tabs: 1 + COUNTED_TABS.filter((tab) => tabs.includes(tab)).length,
    shaped: !tabs.includes('assignments'),
  };
}
